import React, { useEffect, useMemo, useState } from 'react';

export default function TalkServiceContainer(props) {
  useEffect(() => {
    return () => {
      //console.log('unmout...');
    };
  }, [props.view]);

  return <talk-service-module is-live="true" is-mobile="false" code={props.channel || 'S01'} />
};